import { render, staticRenderFns } from "./assignSubject.vue?vue&type=template&id=0751a550&scoped=true"
import script from "./assignSubject.vue?vue&type=script&lang=js"
export * from "./assignSubject.vue?vue&type=script&lang=js"
import style0 from "./assignSubject.vue?vue&type=style&index=0&id=0751a550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0751a550",
  null
  
)

export default component.exports